// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae2d6242","453":"f639faaa","732":"22c6de36","977":"b4f8b4e6"}[chunkId] + ".chunk.js";
};